<div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" *ngSubscribe="allowedToCreateNew$ as allowedToCreateNew">
    <!-- Header and add new button -->
    <div class="row justify-content-between no-gutters mb-4">
        <div class="col-auto mr-auto">
            <h1 i18n="@@newscenter-title" class="h4">News Center</h1>
            <ng-container *ngIf="licensed$ | async">
              <app-action-link *ngIf="showNewsCenterLink || allowedToCreateNew" [href]="newsCenterUrl" [target]="'blank'" class="d-block">
                  <span i18n="@@newscenter-sharepoint-link">SharePoint news center</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
              </app-action-link>
            </ng-container>
        </div>
        <div class="col-auto">
            <a mat-flat-button *ngIf="allowedToCreateNew && lightEnabled" [routerLink]="['add']" color="accent" class="ml-2 d-block">
                <span i18n="@@newscenter-create-new-button">Add News</span>
            </a>
        </div>
    </div>
  <ng-container *ngSubscribe="filterChannelGuid$ as filterChannelGuid">
    <app-page-center [pageType]="pageType" [filterChannelGuid]="filterChannelGuid" [editorOptionsEnabled]="allowedToCreateNew"></app-page-center>
  </ng-container>
</div>
